import React from 'react';
import '../../css/components/BackDrop.css';
const backdrop = (props) => {
    return (
        props.show ? 
            <div>
                <div class = "backdrop"></div>
                <div class="progressBarContainer" >
                    <div class="track" >
                        <div  class="progress-bar-striped_custom" percentage={100}>{props.message}</div>
                    </div>
                </div>
            </div>    
        : null
    )
}

export default backdrop;
